import type { TerminalSchema } from "@wishlink/applens-core";
export type {
  QueryTiming,
  DependencyTimings,
  HomeDependencies,
} from "@wishlink/applens-core";
const dependencyRule = {
  type: "enum",
  values: ["network", "inflight", "cache", "absent"],
  default: "absent",
} as const;
export const HOME_TERMINAL_SCHEMA: TerminalSchema = {
  "app.dep.creator_data": dependencyRule,
  "app.dep.creator_config": dependencyRule,
  "app.dep.intent": dependencyRule,
};
